'use strict';

var React = require('react');

var SvgPackageFilledMajor = function SvgPackageFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.884 6.625a2.75 2.75 0 0 0-.434-.858l-.8-1.067c-.33-.44-.85-.7-1.4-.7h-2.625v2.625h5.259Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 4h-2.524a1.75 1.75 0 0 0-1.358.646l-.877 1.08a2.75 2.75 0 0 0-.486.899h5.245v-2.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 7.875h12v6.375a1.75 1.75 0 0 1-1.75 1.75h-8.5a1.75 1.75 0 0 1-1.75-1.75v-6.375Zm2.5 4.875v-2a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75Z"
  }));
};
SvgPackageFilledMajor.displayName = "PackageFilledMajor";

exports.SvgPackageFilledMajor = SvgPackageFilledMajor;
